import React, { useMemo } from "react";
import { EmptyStateErro } from "../../components/EmptyState";
import PainelTabela from "../../components/PainelTabela";
import { PageLoader } from "../../components/LoadingMarcenaria";
import { useDados } from "../../context/DadosContext";
import { F } from "../../utils/gerencialFields";
import { compareDatesAsc, toDate } from "../../utils/status";

const COLUNAS = [
  { key: "cliente", label: "Cliente" },
  { key: "ambiente", label: "Ambiente" },
  { key: "entregaContrato", label: "Entrega Prevista", labelCurto: "entrega", tipo: "data" },
  { key: "carregamento", label: "Data Entrega", labelCurto: "entregue", tipo: "data" },
  { key: "valor", label: "Valor", labelCurto: "valor", tipo: "moeda" },
  { key: "status", label: "Status" },
];

export default function Obras() {
  const { dados, erro, initialLoading } = useDados();

  // Memoizado (e antes dos early-returns — Rules of Hooks): sem isso, cada
  // re-render recriava `linhas` (filter+map+sort de 400+ itens) e a nova
  // referência invalidava toda a cadeia de memos do PainelTabela.
  const linhas = useMemo(
    () =>
      dados
        .filter((row) => Boolean(row[F.CARREGAMENTO]))
        .map((row) => {
          const entregaContrato = row[F.ENTREGA_PREVISTA];
          const carregamento = row[F.CARREGAMENTO];
          const entregueDepoisDoPrazo =
            Boolean(toDate(entregaContrato) && toDate(carregamento)) &&
            toDate(carregamento) > toDate(entregaContrato);

          return {
            cliente: row[F.NOME_DO_CLIENTE],
            rowPlanilha: row,
            ambiente: row[F.AMBIENTE],
            entregaContrato,
            carregamento,
            valor: row[F.VALOR_DO_AMBIENTE],
            status: entregueDepoisDoPrazo ? "Entregue com atraso" : "Entregue no prazo",
            statusVariant: entregueDepoisDoPrazo ? "danger" : "success",
          };
        })
        .sort((left, right) => compareDatesAsc(right.carregamento, left.carregamento)),
    [dados],
  );

  const totalizadores = useMemo(
    () => [
      { label: "Total Entregues", valor: linhas.length },
      {
        label: "No Prazo",
        valor: linhas.filter((linha) => linha.statusVariant === "success").length,
      },
      {
        label: "Com Atraso",
        valor: linhas.filter((linha) => linha.statusVariant === "danger").length,
      },
    ],
    [linhas],
  );

  if (initialLoading) {
    return <PageLoader scope="obras" />;
  }

  if (erro) {
    return <EmptyStateErro erro={erro} />;
  }

  return (
    <PainelTabela
      titulo="Histórico de Entregas"
      labelContagem="Total entregue"
      colunas={COLUNAS}
      linhas={linhas}
      totalizadores={totalizadores}
      densidade="compact"
      persistirNoBackend
    />
  );
}
